/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text, type TextProps } from '@lib/canvasx/components/Text';
import FontAwesomeGlyphs, {
  type FontAwesomeIconName,
} from './FontAwesomeGlyphs';

// We could add the other styles if we wanted, just need to map font family
const FaIconFontFaces = {
  regular: 'Font Awesome 6 Pro',
  solid: 'Font Awesome 6 Pro',
};

type FaIconStyle = keyof typeof FaIconFontFaces;

export interface FaIconProps extends Omit<Partial<TextProps>, 'face' | 'bold'> {
  style?: FaIconStyle;
  icon: FontAwesomeIconName;
}

export const FaIcon: CanvaSXFC<Omit<FaIconProps, 'children'>> = function ({
  icon,
  style = 'regular',
  ...props
}) {
  const face = FaIconFontFaces[style];
  const glyph = FontAwesomeGlyphs[icon];

  return (
    <Text face={face} bold={style === 'solid'} {...props}>
      {String.fromCharCode(glyph)}
    </Text>
  );
};
